import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PracticeState {
  currentPractice: IPractice;
  allPractices: IPractice[];
  originalPractices: IPractice[];
  rightPanel: "main" | "alternate";
  currentSelectedContentId: number | null;
  alterantesOptions: IConfig[];
  alternateRequirements: string;
}

export const initialPractice = {
  _id: "",
  title: "",
  type: "",
  content: [],
  module: "",
  customPractice: "",
  status: "",
};

const initialState: PracticeState = {
  currentPractice: initialPractice,
  allPractices: [],
  originalPractices: [],
  rightPanel: "main",
  currentSelectedContentId: null,
  alterantesOptions: [],
  alternateRequirements: "",
};

const practiceSlice = createSlice({
  name: "practice",
  initialState,
  reducers: {
    setCurrentPractice: (state, action: PayloadAction<IPractice>) => {
      state.currentPractice = action.payload;
    },
    updatePracticeState: (
      state,
      action: PayloadAction<Partial<PracticeState>>
    ) => {
      Object.assign(state, action.payload);
    },
    clearnPractice: () => initialState,
  },
});

export const { setCurrentPractice, updatePracticeState, clearnPractice } =
  practiceSlice.actions;

export default practiceSlice.reducer;
